import React from 'react';

import PropTypes from 'prop-types';

import MainFont from 'ui/typography/mainFont';

import CircleIcon from '../CircleIcon';
import { Number, NumberBoxWrapper, NumberIcon } from './style';

const NumberBox = ({
  title,
  children,
  bigNumber,
  align,
  icon,
  iconColor,
  circleSize,
  iconSize,
  numberSize,
  top,
  right,
  position,
  iconMargin,
  unitMeasure,
  centeredContent = false,
  backgroundColor,
  verticalAlign,
  left,
  bulletStatus
}) => (
  <NumberBoxWrapper
    align={align}
    centeredContent={centeredContent}
    verticalAlign={verticalAlign}
  >
    {title && <MainFont type="1">{title}</MainFont>}
    <Number verticalAlign={verticalAlign} bulletStatus={bulletStatus}>
      <MainFont type="5" configuration={{ fontSize: numberSize }}>
        {bigNumber}
      </MainFont>
      {unitMeasure && (
        <MainFont type="5" configuration={{ fontSize: 16, fontWeight: 600 }}>
          {unitMeasure}
        </MainFont>
      )}
    </Number>
    {children}
    {(icon || iconColor) && (
      <NumberIcon
        top={top}
        right={right}
        left={left}
        position={position}
        iconMargin={iconMargin}
        centeredContent={centeredContent}
        verticalAlign={verticalAlign}
      >
        <CircleIcon
          icon={icon}
          circleSize={circleSize}
          iconSize={iconSize}
          iconColor={iconColor}
          specifiedColor={backgroundColor}
        />
      </NumberIcon>
    )}
  </NumberBoxWrapper>
);

NumberBox.defaultProps = {
  bigNumber: 0,
  align: 'center',
  iconSize: '24',
  top: '0',
  right: '20',
  numberSize: 30,
  position: 'absolute',
  verticalAlign: false
};

NumberBox.propTypes = {
  title: PropTypes.string,
  align: PropTypes.string,
  bigNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  circleSize: PropTypes.string,
  numberSize: PropTypes.number,
  iconSize: PropTypes.string,
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  position: PropTypes.string,
  iconMargin: PropTypes.string,
  unitMeasure: PropTypes.string,
  centeredContent: PropTypes.bool,
  backgroundColor: PropTypes.string,
  verticalAlign: PropTypes.bool,
  bulletStatus: PropTypes.bool
};

export default NumberBox;
